<template>
	<div style="position: relative;">
		<v-container>
			<v-row>
				<v-col cols="12" md="6">
					<h1 class="orange--text text--darken-2 ff-emkan-bold fs-h3">{{ content.title }}</h1>
					<p class="text--primary text-justify line-height-2d5">
						{{ content.desc }}
					</p>
					<v-list dense>
						<v-list-item v-for="(item, idx) in content.slides" :key="idx">
							<v-list-item-avatar>
								<v-icon class="orange lighten-1" dark>
									mdi-check
								</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="ff-emkan-bold fs-h5 mb-2">{{ item.title }}</v-list-item-title>
								<v-list-item-title class="fs-h6">{{ item.desc }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<div class="text-center mt-4">
						<v-btn class="rounded-xl" color="secondary" elevation="5" @click="$emit('scroll', 'loanCalculator')">
							درخواست خود را ثبت کنید
						</v-btn>
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<v-img :src="content.mainImg.src" :max-height="`${content.maxHeight}px`" />
				</v-col>
			</v-row>
		</v-container>

		<div v-if="editable" style="position: absolute;top: 0; left: 0;">
			<v-btn small color="secondary" outlined @click="edit()">ویرایش</v-btn>
		</div>

		<v-dialog v-model="settingsDialog" persistent max-width="650px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تنظیمات سکشن اول</span></div>
					<v-spacer />
					<v-btn @click="settingsDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container v-if="settingsDialog">
						<v-row>
							<v-col cols="12" md="4">
								<div>تصویر اصلی</div>
								<ImageUploader :ref="'mainImageUploader'" v-model="settings.mainImg.src" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(settings.mainImg.src)" @delete="() => { settings.mainImg.src = '' }" />
							</v-col>
							<v-col cols="8">
								<v-text-field dense v-model="settings.maxHeight" type="number" label="حداکثر ارتفاع تصویر اصلی"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-text-field dense v-model="settings.title" label="عنوان"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-textarea dense v-model="settings.desc" label="شرح"></v-textarea>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card color="#eee" elevation="0" v-for="(slide, idx) in settings.slides" :key="idx" class="mb-3">
									<v-card-title class="d-flex justify-space-between">
										<h3>آیتم {{ idx + 1 }}</h3>
										<v-btn color="red" text small @click="removeSlide(idx)">حذف</v-btn>
									</v-card-title>
									<v-divider></v-divider>
									<v-card-text>
										<v-row>
											<v-col cols="12" md="8">
												<div>
													<v-text-field dense v-model="slide.title" label="عنوان"></v-text-field>
												</div>
												<div>
													<v-text-field dense v-model="slide.desc" class="" label="زیر عنوان"></v-text-field>
												</div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
								<div class="px-3 text-center">
									<v-btn small color="secondary" @click="addSlide()">افزودن آیتم</v-btn>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="settingsDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" dark @click="submitEdit" :loading="submitEditLoading">
						ذخیره
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import { cloneDeep, isEmpty } from 'lodash'
	import { siteContentRootPath } from '@/util/enums'
	import { get } from 'vuex-pathify'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'


	export default {
		name: 'DefaultTopSection',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean }
		},
		components: {
			ImageUploader
		},
		data: () => ({
			settings: {},
			localData: null,
			settingsDialog: false,
			submitEditLoading: false
		}),
		computed: {
			...get('siteConfig', [
				'customerCode', 'fullTitle'
			]),
			...get('appSettings', [
				'landingSettings'
			]),
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle
			},
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			}
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content)
				}
			}
			else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent()
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					title: this.businessTitle,
					desc: `${this.businessTitle} پلتفرمی است برای اعطای اعتبار برای خرید اقساطی کالا و خدمات که با توجه به مشکلات اقتصادی جامعه شرایطی را برای خرید اقساطی بدون ضامن مهیا کرده. کافی است طرح خرید اقساطی مورد نظر خود را انتخاب کنید و درخواست خود را ثبت کنید و در هر مرحله از ثبت درخواست می توانید سوال یا مشکل خود را با ما درمیان بگذارید و از راهنمایی کارشناسان ما استفاده کنید. ${this.businessTitle} آماده همکاری با فروشگاه ها و سازمان ها می باشد`,
					maxHeight: 450,
					mainImg: { val: '', type: 'img', src: '/choose-us.png' },
					slides: [{
						title: 'خرید اقساطی حتی بدون ضامن',
						desc: 'بدون ضامن اعتبار خود را دریافت کنید و کالای مورد نظر خود را خرید کنید',
					},
					{
						title: 'بدون نیاز به مراجعه حضوری',
						desc: `در هر شهری که هستید میتونید از ${this.businessTitle} خرید اقساطی کنید`,
					},
					{
						title: 'اعتبار سنجی سریع',
						desc: 'مراحل اعتبارسنجی مشتریان عزیز به صورت آنلاین و در کمترین زمان انجام می شود',
					}]
				}
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			submitEdit() {
				this.submitEditLoading = true
				this.processImages().then(res => {
					const data = cloneDeep(this.localData)
					data.content = JSON.stringify(this.settings)
					api.post(`admin/SiteContent/CreateUpdate`, data)
						.then(response => {
							this.localData.content = cloneDeep(this.settings)
							toast.success('اطلاعات با موفقیت ذخیره شد.')
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => { })
				}).catch(err => { })
					.finally(f => {
						this.submitEditLoading = false
						this.settingsDialog = false
					})
			},
			removeSlide(idx) {
				this.settings.slides.splice(idx, 1)
			},
			addSlide() {
				this.settings.slides.push({
					name: '',
					url: '',
					img: { val: '', type: 'img', src: '' }
				})
			},
			processImages() {
				return new Promise(async (resolve, reject) => {
					const formData = new FormData()
					var fileUploader = this.$refs.mainImageUploader
					if (fileUploader && fileUploader.hasFile()) {
						formData.append(`File`, fileUploader.getFile())
						formData.append(`fileName`, this.settings.mainImg.val)
						await api.post('admin/SiteContent/CreateUpdateImage', formData, { contentType: 'multipart/form-data' })
							.then(response => {
								this.settings.mainImg.val = response
								this.settings.mainImg.src = `${siteContentRootPath}${this.ccode}/${response}`
							})
							.catch(err => {
								toast.error(err.message)
								reject()
							})
							.finally(x => { })
					} else if (this.settings.mainImg.val && !this.settings.mainImg.src) {
						await api.post('admin/SiteContent/DeleteImage', { fileName: this.settings.mainImg.val })
							.catch(err => {
								toast.error(err.message)
								reject()
							})
					}
					resolve()
				})
			}
		},
	}
</script>

<style lang="scss"></style>